import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

// Dependencies
import moment from 'moment';

let obx = observable({
  fundingRules: [],
  fundingRuleData: {},
  resetFundingRule: action(function() {
    obx.fundingRuleData = {};
  }),
  // Get all funding rules
  getFundingRules: action(function(onlyInstitution) {
    SessionStore.startLoading('Loading…', 'FundingRules');
    obx.resetFundingRule();

    api.get(`/installs/${SessionStore.userData.installSid}/fundingRules`)
      .then(response => {
        if(onlyInstitution) {
          // Only show rules that are institution-wide
          let filteredFundingRules = [];

          response.data.results.forEach(function(rule){
            if(!rule.courseSid && !rule.examSid && !rule.enrollmentSid && !rule.userSid && !rule.courseOfferingSid) {
              filteredFundingRules.push(rule);
            }
          });

          obx.fundingRules = filteredFundingRules;
        } else {
          // Otherwise show everything
          obx.fundingRules = response.data.results;
        }

        SessionStore.finishLoading('FundingRules');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get filtered funding rules (i.e. filter by course, exam, enrollment)
  getFilteredFundingRules: action(function(scope, sid) {
    obx.resetFundingRule();

    SessionStore.startLoading('Loading…', 'FundingRules');

    api.get(`/installs/${SessionStore.userData.installSid}/fundingRules?${scope}=${sid}`)
      .then(response => {
        obx.fundingRules = response.data.results;
        SessionStore.finishLoading('FundingRules');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get a single funding rule
  getFundingRule: action(function(sid, component) {
    SessionStore.startLoading('Loading…', 'FundingRule');
    obx.resetFundingRule();

    api.get(`/installs/${SessionStore.userData.installSid}/fundingRules/${sid}`)
      .then(response => {
        obx.fundingRuleData = response.data;
        SessionStore.finishLoading('FundingRule');

        // Update the component state
        component.setState({
          fundingRuleData: response.data,
          startDate: moment(response.data.effectiveDate),
          endDate: moment(response.data.expirationDate)
        })

        // Make sure dates are formatted correctly
        let fundingRuleData = {...component.state.fundingRuleData};
        fundingRuleData.effectiveDate = moment.utc(response.data.effectiveDate).local().format('YYYY/MM/DD')
        fundingRuleData.expirationDate = moment.utc(response.data.expirationDate).local().format('YYYY/MM/DD')

        component.setState({
          fundingRuleData
        })
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  createFundingRule: action(function(data, func) {
    SessionStore.startLoading('Loading…', 'AddFundingRules');
    // Remove empty SIDs
    if(!data.courseSid.length) {
      delete data.courseSid;
    }

    if(!data.examSid.length) {
      delete data.examSid;
    }

    if(!data.enrollmentSid.length) {
      delete data.enrollmentSid;
    }

    if(!data.userSid.length) {
      delete data.userSid;
    }

    if(!data.courseOfferingSid.length) {
      delete data.courseOfferingSid;
    }

    api.post(`/installs/${SessionStore.userData.installSid}/fundingRules`, data)
      .then(response => {
        SessionStore.finishLoading('AddFundingRule');

        // Run the callback (close drawer)
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  updateFundingRule: action(function(sid, data, func) {
    SessionStore.startLoading('Loading…', 'UpdateFundingRules');
    // Remove empty sid properties
    if(!data.courseOfferingSid) {
      delete data.courseOfferingSid;
    }
    if(!data.courseSid) {
      delete data.courseSid;
    }
    if(!data.examSid) {
      delete data.examSid;
    }
    if(!data.enrollmentSid) {
      delete data.enrollmentSid;
    }
    if(!data.userSid) {
      delete data.userSid;
    }

    if(!data.description) {
      data.description = ''
    }

    // Remove unnecessary properties
    delete data.sid;
    delete data.applicationInstallSid;
    delete data.createdDate;
    delete data.lastModifiedDate;

    api.put(`/installs/${SessionStore.userData.installSid}/fundingRules/${sid}`, data)
      .then(response => {
        SessionStore.finishLoading('UpdateFundingRules');
        // Run the callback (close drawer)
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  deleteFundingRule: action(function(sid, func) {
    api.delete(`/installs/${SessionStore.userData.installSid}/fundingRules/${sid}`)
      .then(response => {
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/FundingRuleStore.js